import React from 'react';
import { Box, Typography } from '@mui/material';
import { homeDigitalMarketingServices } from './homeContent';
import { Link } from 'react-router-dom';
import { acme, acmeMarketingSectionTitleSx, acmeMarketingEyebrowSx, acmeMarketingBodyLeadSx } from '../../theme/acmeTheme';
import { Card, CardContent, Button } from '../ui';

export default function HomeServicesSection() {
  return (
    <Box
      id="features-section"
      sx={{
        py: { xs: 8, md: 12 },
        px: { xs: 2, md: 4 },
        backgroundColor: acme.colors.background,
      }}
    >
      <Box sx={{ maxWidth: 1200, mx: 'auto' }}>
        <Box sx={{ textAlign: 'center', mb: { xs: 6, md: 8 } }}>
          <Typography
            variant="overline"
            sx={{
              ...acmeMarketingEyebrowSx,
              color: acme.colors.mutedForegroundSolid,
              fontSize: '0.75rem',
              letterSpacing: '0.12em',
              mb: 2,
              display: 'block',
            }}
          >
            OUR SERVICES
          </Typography>
          <Typography
            component="h2"
            sx={{
              ...acmeMarketingSectionTitleSx,
              color: acme.colors.foreground,
              mb: 2,
              fontSize: { xs: '2rem', md: '2.75rem' },
            }}
          >
            Everything you need to grow
          </Typography>
          <Typography
            sx={{
              ...acmeMarketingBodyLeadSx,
              color: acme.colors.mutedForegroundSolid,
              maxWidth: 560,
              mx: 'auto',
              fontSize: { xs: '1rem', md: '1.1rem' },
            }}
          >
            From strategy to execution — email, SMS, and contact tools in one modern platform
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
            gap: 3,
          }}
        >
          {homeDigitalMarketingServices.map((service) => (
            <Card key={service.title} sx={{ height: '100%' }}>
              <CardContent sx={{ display: 'flex', flexDirection: 'column', height: '100%', gap: 2 }}>
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: acme.radius.md,
                    backgroundColor: acme.colors.muted,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: acme.colors.foreground,
                    '& .MuiSvgIcon-root': { fontSize: 28 },
                  }}
                >
                  {service.icon}
                </Box>
                <Typography sx={{ fontWeight: 600, fontSize: '1.125rem', color: acme.colors.foreground }}>
                  {service.title}
                </Typography>
                <Typography sx={{ color: acme.colors.mutedForegroundSolid, lineHeight: 1.7, flex: 1 }}>
                  {service.text}
                </Typography>
              </CardContent>
            </Card>
          ))}
        </Box>

        <Box sx={{ textAlign: 'center', mt: 8 }}>
          <Button component={Link} to="/register" sx={{ borderRadius: acme.radius.md, px: 4 }}>
            Get started free
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
